var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('v-snackbar',{attrs:{"timeout":_vm.timeout},model:{value:(_vm.shouldShow),callback:function ($$v) {_vm.shouldShow=$$v},expression:"shouldShow"}},[_vm._v(" "+_vm._s(_vm.message)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }